<template>
  <el-dialog
    :title="'Order List : '+detail.courierName"
    :visible.sync="detail.dialog"
  >
    <el-row>
      <el-col
        :span="12"
        :offset="6"
      >
        <el-input
          v-model="filters[0].value"
          placeholder="ค้นหาออเดอร์"
        ></el-input>
      </el-col>
      <el-col
        :span="12"
        :offset="6"
        style="margin-top:20px;"
      >
        <data-tables
          :data="detail.orderList"
          :filters="filters"
          class="dataTable"
          :page-size="10"
          :pagination-props="{ pageSizes: [10, 20, 50, 100], pagerCount: 5 }"
        >
          <el-table-column
            label="No"
            prop="no"
          >

          </el-table-column>
          <el-table-column
            label="orderNumber"
            prop="orderNumber"
          >
            <div
              class="text-md-left"
              slot-scope="scope"
            >
            <a
              href="#"
              @click="handleOrderNumberDetail(scope.row.orderNumber)"
            >{{ scope.row.orderNumber }}</a>
            </div>

          </el-table-column>
        </data-tables>
      </el-col>
    </el-row>

  </el-dialog>
</template>
<script>
export default {
    name: 'DialogNewCustomerCreateOrderList',
    props: {
        detail: {
            type: Object
        }
    },
    data () {
        return {
            filters: [{ prop: 'orderNumber', value: '' }]
        }
    },
    watch: {
        'detail.dialog': function (val) {
            if (val === false) {
                this.filters[0].value = ''
            }
        }
    },
    methods: {
        handleOrderNumberDetail (orderNumber) {
            let route = this.$router.resolve({
                path: `/oms/logOrder/LogOrderDetail`,
                query: { orderId: orderNumber }
            })
            window.open(route.href, '_blank') // New tab
        }
    }
}
</script>
